module.exports = __webpack_public_path__ + "static/img/bg-item3.f71ecee9.png";